import type { Bookmark } from "./helpers/bookmark_helper";

interface BookmarkTippyContentProps {
  bookmark?: Bookmark;
}

export const BookmarkTippyContent = ({
  bookmark,
}: BookmarkTippyContentProps) => {
  const name = bookmark?.name;
  const url = bookmark?.url;

  return (
    <div className="break-words text-center">
      <strong>{name}</strong>
      <br />
      {url}
    </div>
  );
};
